import { GraphQLEnumType } from 'graphql'

export type GradeValue = 'A' | 'B' | 'C' | 'D' | 'F' | 'UNKNOWN'

export const knownGrades: GradeValue[] = ['A', 'B', 'C', 'D', 'F']

export const GradeValueType = new GraphQLEnumType({
  name: 'GradeValue',
  description: 'A letter representation of a score',
  values: {
    A: {},
    B: {},
    C: {},
    D: {},
    F: {},
    // FYI GraphQLEnumType does not allow special characters
    UNKNOWN: {}
  }
})
